import {Component, HostListener, inject, OnInit, Signal} from '@angular/core';
import {NgClass} from '@angular/common';
import {ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive} from '@angular/router';
import {filter, map, Subscription} from 'rxjs';
import {EmployeeRole} from '../../auth/enums/employee-role';
import {ColorService} from '../../core/services/color-service';
import {InputSwitch} from '../input-switch/input-switch';
import {DarkModeService} from '../../core/services/dark-mode-service';
import {ProfileSync} from '../../auth/services/profile-sync';
import {ILoginResponse} from '../../auth/models/i-login-response';
import {toSignal} from '@angular/core/rxjs-interop';
import {environment} from '../../../environments/environment.local';
import {PwaService} from '../services/pwa-service';
import {NotificationService} from '../services/notification-service';

@Component({
  selector: 'dm-sidebar',
  imports: [
    NgClass,
    RouterLink,
    InputSwitch,
    RouterLinkActive
  ],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar implements OnInit {
  profileSync: ProfileSync = inject(ProfileSync);
  colorService: ColorService = inject(ColorService);
  darkModeService: DarkModeService = inject(DarkModeService);
  route: ActivatedRoute = inject(ActivatedRoute);
  router: Router = inject(Router);
  pwaService: PwaService = inject(PwaService);
  notificationService: NotificationService = inject(NotificationService);

  hideSidebar = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => {
        const url = (event as NavigationEnd).urlAfterRedirects;
        // Nascondi se è la root OPPURE se inizia con /auth
        return url === '/' || url.startsWith('/auth');
      })
    ),
    { initialValue: this.router.url === '/' || this.router.url.startsWith('/auth') }
  );

  visible: boolean = false;
  bgColor!: string;
  theme!: string;

  user: Signal<ILoginResponse | null> = this.profileSync.user;
  isLogged: Signal<boolean> = this.profileSync.isLogged;

  userSubscription!: Subscription;
  bgColorSubscription!: Subscription;
  themeSubscription!: Subscription;

  ngOnInit() {
    this.getColor();
    this.getTheme();
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }

    if (this.bgColorSubscription) {
      this.bgColorSubscription.unsubscribe();
    }

    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
  }

  getColor(): void {
    this.colorService.bgColor$.subscribe(data => {
      this.bgColor = data;
    })
  }

  getTheme(): void {
    this.darkModeService.theme$.subscribe(data => {
      this.theme = data;
    })
  }

  toggleTheme(): void {
    this.darkModeService.toggleTheme();
  }

  open(): void {
    this.visible = true;
  }

  close(): void {
    this.visible = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.visible) return;

    const clickedElement = event.target as HTMLElement;
    const isClickInsideMenuContainer = clickedElement.closest('#sidebar, #sidebar-toggler');

    if (!isClickInsideMenuContainer) this.visible = false;
  }

  protected readonly EmployeeRole = EmployeeRole;
  protected readonly environment = environment;
}
